<template>
  <div id="app">
    <template v-if="isLoginPage || isHomePage">
      <router-view />
    </template>
    <template v-else-if="isLoggedIn">
      <header class="header">
        <div class="logo-container">
          <img src="./assets/logo.svg" class="logo" alt="Logo" />
          <span class="logo-text">SmartAI</span>
        </div>
        <div class="right-menu">
          <router-link to="/" class="nav-item">
            <i class="el-icon-s-home"></i>
          </router-link>
          <router-link to="/" class="nav-item">
            <i class="el-icon-document"></i>
          </router-link>
          <router-link to="/" class="nav-item">
            <i class="el-icon-folder"></i>
          </router-link>
          <el-button type="primary" size="small" class="version-btn">基础版</el-button>

          <el-dropdown @command="handleCommand" trigger="click">
            <div class="user-info">
              <el-avatar size="small" class="user-avatar">
                <i class="el-icon-user-solid"></i>
              </el-avatar>
              <span class="username">{{ userName }}</span>
              <i class="el-icon-arrow-down user-dropdown-icon"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <el-dropdown-item command="profile">
                <i class="el-icon-user"></i>
                <span>我的账户</span>
              </el-dropdown-item>
              <el-dropdown-item command="settings">
                <i class="el-icon-setting"></i>
                <span>账户设置</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="logout" class="logout-item">
                <i class="el-icon-switch-button"></i>
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <div class="main-container">
        <aside class="sidebar">
          <el-menu :default-active="activeMenuItem" class="sidebar-menu" router background-color="#f5f7fa"
            text-color="#303133" active-text-color="#409EFF">
            <el-menu-item-group title="发现">
              <el-menu-item index="/template">
                <i class="el-icon-collection"></i>
                <span>模板中心</span>
              </el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="创造">
              <el-menu-item index="/workflow">
                <i class="el-icon-set-up"></i>
                <span>工作流</span>
              </el-menu-item>
              <el-menu-item index="/plugin">
                <i class="el-icon-magic-stick"></i>
                <span>插件</span>
              </el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="管理">
              <el-menu-item index="/model">
                <i class="el-icon-cpu"></i>
                <span>模型管理</span>
              </el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="接入">
              <el-menu-item index="/dialogue">
                <i class="el-icon-chat-line-round"></i>
                <span>对话管理</span>
              </el-menu-item>
              <el-menu-item index="/channel">
                <i class="el-icon-connection"></i>
                <span>渠道接入</span>
              </el-menu-item>
              <el-menu-item index="/client">
                <i class="el-icon-mobile-phone"></i>
                <span>客户端</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-menu>
        </aside>

        <main class="main-content">
          <router-view />
        </main>
      </div>
    </template>
    <template v-else>
      <redirect-to-home></redirect-to-home>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      userName: 'uLike'
    }
  },
  components: {
    RedirectToHome: {
      created () {
        this.$router.replace('/')
      },
      render: h => h()
    }
  },
  computed: {
    activeMenuItem () {
      return this.$route.path
    },
    isLoginPage () {
      return this.$route.path === '/login'
    },
    isHomePage () {
      return this.$route.path === '/'
    },
    isLoggedIn () {
      return localStorage.getItem('isLoggedIn') === 'true'
    }
  },
  created () {
    // 从本地存储获取用户名
    const storedUserName = localStorage.getItem('userName')
    if (storedUserName) {
      this.userName = storedUserName
    }
  },
  methods: {
    handleCommand (command) {
      if (command === 'logout') {
        // 清除登录状态
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('userName')

        // 跳转到首页
        this.$router.push('/')

        this.$message.success('已退出登录')
      } else if (command === 'profile') {
        this.$message.info('个人资料功能开发中')
      } else if (command === 'settings') {
        this.$message.info('账户设置功能开发中')
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 14px;
  background-color: #f5f7fa;
  color: #333;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  height: 56px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.right-menu {
  display: flex;
  align-items: center;
}

.nav-item {
  color: #606266;
  font-size: 18px;
  margin-right: 20px;
  text-decoration: none;
  transition: color 0.3s;
}

.nav-item:hover {
  color: #409EFF;
}

.version-btn {
  margin-right: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: #f5f7fa;
}

.user-avatar {
  margin-right: 8px;
  background-color: #409EFF;
}

.username {
  font-size: 14px;
  margin-right: 5px;
  color: #303133;
  font-weight: 500;
}

.user-dropdown-icon {
  font-size: 12px;
  color: #909399;
}

/* 下拉菜单样式 */
.el-dropdown-menu.user-dropdown-menu {
  padding: 6px 0;
  min-width: 140px !important;
}

.el-dropdown-menu__item {
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
}

.el-dropdown-menu__item i {
  margin-right: 10px;
  width: 16px;
  text-align: center;
  font-size: 16px;
  vertical-align: middle;
}

.el-dropdown-menu__item span {
  vertical-align: middle;
}

/* 退出登录选项样式 */
.logout-item,
.logout-item i {
  color: #F56C6C !important;
}

/* 分隔线样式 */
.el-dropdown-menu__item--divided {
  border-top: 1px solid #ebeef5;
  margin: 5px 0;
}

.el-dropdown-menu__item--divided:before {
  height: 5px;
}

.main-container {
  display: flex;
  margin-top: 56px;
  flex: 1;
}

.sidebar {
  width: 200px;
  background-color: #f5f7fa;
  border-right: 1px solid #e6e6e6;
  position: fixed;
  height: calc(100vh - 56px);
  top: 56px;
  left: 0;
  z-index: 99;
  overflow-y: auto;
}

.sidebar-menu {
  border-right: none;
}

.el-menu-item-group__title {
  padding-left: 20px !important;
  font-size: 12px;
  color: #909399;
}

.el-menu-item {
  height: 50px;
  line-height: 50px;
}

.el-menu-item i {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  padding: 20px;
  overflow-y: auto;
}
</style>